<template>
  <div class="tabs-pane">
    <div class="item" @click="show = !show" :class="{active:show,haschild:list.children&&list.children.length}">
      <!--<i class="iconfont icon-gengxin-xuankuang" v-if="!isChecked&&!list.children" @click="chooseMember(list.label)"></i>
      <i class="iconfont icon-xuankuang" v-if="isChecked&&!list.children" @click="chooseMember(list.label)"></i>-->
      <div class="g-sanjiao" :style="{transform: show ? 'rotate(180deg)' : 'rotate(0)'}" v-if="isRadio ? list.children.length : (list.userInfos.length || list.children.length)"></div>
      <i v-if="isRadio && $store.state.chooseBranch.id !== list.id" class="iconfont icon-dianxuanweixuan" @click.stop="chooseRadio(list)"></i>
      <i v-if="isRadio && $store.state.chooseBranch.id === list.id" class="iconfont icon-dianxuanxuanzhong"></i>
      <!--<div class="g-radio" v-if="isRadio && $store.state.chooseBranch.id !== list.id" @click.stop="chooseRadio(list)">选择</div>-->
      {{list.label}}
    </div>

    <transition name="slide-down">
      <div v-show="show">
        <v-checkbox v-if="!isRadio" v-for="(cel,index) in list.userInfos" :item="cel" :key="cel.userInfoId"></v-checkbox>
        <v-tabsPane v-for='(cel,index) in list.children' :list='cel' :isRadio="isRadio" :closeChoose="closeChoose" :key="cel.label"></v-tabsPane>
      </div>
    </transition>
  </div>
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    name: 'items',
    data () {
      return {
        show: false,
      }
    },
    props: ['list', 'isRadio', 'closeChoose'],
    created () {
    },
    computed: {},
    methods: {
      chooseRadio (item) {
        this.$store.state.chooseBranch = {
          id: item.id,
          name: item.label,
        };
        if (this.closeChoose) {
          this.closeChoose();
        }
      }
    },
    components: {},
    watch: {
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .g-radio{
    width: 1rem;
    line-height: .6rem;
    text-align: center;
    @include sc(.28rem,#fff);
    background: #D60000;
    border-radius: .1rem;
    margin-right: .1rem;
  }
  .g-sanjiao{
    @include wh(0,0);
    margin-right: .1rem;
    border-style: solid;
    border-width: .18rem .13rem;
    border-color: transparent transparent #BBBBBB transparent;
    margin-top: -.18rem;
    transition: transform .2s linear;
    transform-origin: center .27rem;
  }
  .tabs-pane{
    padding-left: .46rem;
    border-bottom: .02rem solid #eee;
    .item{
      position: relative;
      display: flex;
      align-items: center;
      z-index: 1;
      line-height: .88rem;
      @include sc(.28rem,#333);
      font-weight: 700;
      background: #fff;
      &.active{
        border-bottom: .02rem solid #eee;
      }
      &:last-child{
        border-bottom: 0;
      }
    }
    i{
      display: inline-block;
      @include sc(.28rem,#676A88);
      margin-right: .16rem;
      &.icon-xuankuang,&.icon-dianxuanxuanzhong{
        color: #009DFF;
      }
    }
    .tabs-info{
    }
    &:last-child{
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// tabs-pane.vue?3dfd1e56